import React, { Component } from 'react';
import _ from 'lodash';
import ProjectsEditLayout from '../../templates/projects';
import ProjectGoalsEditForm from '../../elements/projects/goals';
import Loading from "../../elements/loading";

class ProjectEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			(projects.isFetching || _.isEmpty(projects.goals)) ? <Loading message="Cargando..." />:<ProjectGoalsEditForm {...this.props}/>
		);
	}

	componentDidMount() {
		this.props.fetchProjectsGoalsEdit(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectEdit, {subnav: 2});



// WEBPACK FOOTER //
// ./src/layouts/projects/goals.jsx